import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { joinRoom, playerStorageKey } from "./api";
import "./jeopardy.css";

export default function JeopardyHome() {
    const navigate = useNavigate();
    const [joinCode, setJoinCode] = useState("");
    const [joinName, setJoinName] = useState("");
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);

    async function handleJoin(e) {
        e.preventDefault();
        const code = joinCode.trim().toUpperCase();
        const name = joinName.trim();
        if (!code || !name) return;
        setBusy(true);
        setError(null);
        try {
            const res = await joinRoom(code, name);
            if (res.error) throw new Error(res.error);
            localStorage.setItem(
                playerStorageKey(code),
                JSON.stringify({ playerId: res.playerId, token: res.token, name })
            );
            navigate(`/jeopardy/${code}`);
        } catch (e) {
            setError("Could not join that game. Check the code and try again.");
            setBusy(false);
        }
    }

    return (
        <div className="jpd-home">
            <h1 className="jpd-title">Jeopardy</h1>

            <div className="jpd-panel" style={{ textAlign: "center" }}>
                <h2>Host a game</h2>
                <p>Pick a saved game (or the built-in sample) and get a room code to share.</p>
                <Link className="jpd-btn jpd-btn-primary" to="/jeopardy/host">
                    Host a Game
                </Link>
            </div>

            <div className="jpd-panel">
                <h2>Join a game</h2>
                <form onSubmit={handleJoin} className="jpd-join-form">
                    <input
                        className="jpd-input"
                        placeholder="Room code"
                        value={joinCode}
                        onChange={(e) => setJoinCode(e.target.value)}
                        maxLength={8}
                    />
                    <input
                        className="jpd-input"
                        placeholder="Your name"
                        value={joinName}
                        onChange={(e) => setJoinName(e.target.value)}
                        maxLength={40}
                    />
                    <button className="jpd-btn" type="submit" disabled={busy}>
                        Join Game
                    </button>
                </form>
            </div>

            <div className="jpd-panel" style={{ textAlign: "center" }}>
                <h2>Build a game</h2>
                <p>Create or edit the categories, questions, and images for a game.</p>
                <Link className="jpd-btn" to="/jeopardy/builder">
                    Open Game Builder
                </Link>
            </div>

            {error && <div className="jpd-error">{error}</div>}
        </div>
    );
}
